
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import AccountDetails from "@/components/dashboard/AccountDetails.vue";
import { getCurrentUser } from "@/utils/index";
import { getDashboardData } from "@/api/dashboard";
import { settingsdata } from "@/api/settings";
import DashboardProfileHeader from "@/components/dashboard/DashboardProfileHeader.vue";
import PMAReminderNotice from "@/components/dashboard/PMAReminderNotice.vue";
import ECShopAdvisory from "@/views/ECShopAdvisory.vue";
import HeroBalanceCard from "@/components/dashboard/sequence/HeroBalanceCard.vue";
import DashboardMovableBlock from "@/components/dashboard/DashboardMovableBlock.vue";
import {
  MovableBlockId,
  MovableBlockState,
  MOVABLE_BLOCK_LABELS,
  canMoveBlockDown,
  canMoveBlockUp,
  getBlocksInZone,
  loadDashboardLayout,
  moveBlockDown,
  moveBlockUp,
  saveDashboardLayout,
} from "@/utils/dashboardLayout";

export default defineComponent({
  name: "dashboarddtc",
  components: {
    AccountDetails,
    DashboardProfileHeader,
    PMAReminderNotice,
    ECShopAdvisory,
    HeroBalanceCard,
    DashboardMovableBlock,
  },
  data() {
    return {
      user: {},
      currency: "",
      lifetimeIncome: 0 as number | string,
      lifetimeCurrency: "",
      rankPrimeImage: "",
      rankPrime: "",
      currentRank: "",
      showRankImage: true,
      coverPhoto: "media/cover/unstoppabull.png",
      pt: "",
      layoutBlocks: [] as MovableBlockState[],
    };
  },
  computed: {
    aboveBlocks(): MovableBlockState[] {
      return getBlocksInZone(this.layoutBlocks, "above");
    },
    belowBlocks(): MovableBlockState[] {
      return getBlocksInZone(this.layoutBlocks, "below");
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
  methods: {
    blockLabel(id: MovableBlockId): string {
      return MOVABLE_BLOCK_LABELS[id];
    },
    canMoveUp(id: MovableBlockId): boolean {
      return canMoveBlockUp(this.layoutBlocks, id);
    },
    canMoveDown(id: MovableBlockId): boolean {
      return canMoveBlockDown(this.layoutBlocks, id);
    },
    moveUp(id: MovableBlockId) {
      this.layoutBlocks = moveBlockUp(this.layoutBlocks, id);
      saveDashboardLayout(this.pt, this.layoutBlocks);
    },
    moveDown(id: MovableBlockId) {
      this.layoutBlocks = moveBlockDown(this.layoutBlocks, id);
      saveDashboardLayout(this.pt, this.layoutBlocks);
    },
    async getDashboardData() {
      try {
        const response = await getDashboardData();
        if (response?.data !== undefined) {
          this.currency = response.data.currency;
          this.applyRankImage(response.data);
          this.applyLifetimeIncome(response.data);
        }
      } catch (error) {
        console.error("Failed to load ECP dashboard data:", error);
      }
    },
    applyLifetimeIncome(data: Record<string, unknown>) {
      const details = data.lifetimeincomedetails as Record<string, unknown> | undefined;
      if (details) {
        this.lifetimeIncome = (details.income ?? details.INCOME ?? 0) as number | string;
        this.lifetimeCurrency = String(
          details.curr ?? details.CURR ?? data.currency ?? this.currency ?? ""
        );
      } else {
        this.lifetimeIncome = 0;
        this.lifetimeCurrency = String(data.currency ?? this.currency ?? "");
      }
    },
    applyRankImage(data: Record<string, unknown>) {
      const rankPrime = data.rankPrime as string | undefined;
      const currentRank = data.currentRank as string | undefined;

      this.rankPrime = rankPrime ?? "";
      this.currentRank = currentRank ?? "";

      if (rankPrime === "SEP" || rankPrime === "GEP" || rankPrime === "GAP") {
        this.rankPrimeImage = `media/rank_logos/${rankPrime}_header.png`;
        this.showRankImage = true;
        return;
      }

      if (currentRank && currentRank !== "DI") {
        this.rankPrimeImage = `media/rank_logos/${currentRank}_header.png`;
        this.showRankImage = true;
      } else {
        this.showRankImage = false;
      }
    },
    async loadCoverPhoto() {
      try {
        const response = await settingsdata();
        if (response?.data?.coverPhotoUrl) {
          this.coverPhoto = response.data.coverPhotoUrl;
        }
      } catch (error) {
        console.error("Failed to load cover photo:", error);
      }
    },
  },
  mounted() {
    this.pt = String(localStorage.getItem("pt") || "ecp");
    this.layoutBlocks = loadDashboardLayout(this.pt);
    this.getDashboardData();
    this.user = getCurrentUser() ?? {};
    this.loadCoverPhoto();
  },
});
